module.exports = __webpack_public_path__ + "static/media/raport_4.e8847fd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/raport_4.jpg
// module id = 1889
// module chunks = 0